import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/components/themeProvider";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "light" } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[hsl(var(--toast-background))] group-[.toaster]:text-[hsl(var(--toast-foreground))] group-[.toaster]:border-[hsl(var(--toast-border))] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[hsl(var(--toast-description))]",
          closeButton:
            "border-current/20 bg-transparent text-current/70 hover:text-current",
          actionButton:
            "group-[.toast]:bg-[hsl(var(--toast-action-bg))] group-[.toast]:text-[hsl(var(--toast-action-foreground))]",
          cancelButton:
            "group-[.toast]:border group-[.toast]:border-[hsl(var(--toast-border))] group-[.toast]:bg-[hsl(var(--toast-cancel-bg))] group-[.toast]:text-[hsl(var(--toast-cancel-foreground))]",
          success:
            "bg-[hsl(var(--toast-success-bg))] text-[hsl(var(--toast-success-foreground))] border-[hsl(var(--toast-success-border))]",
          info: "bg-[hsl(var(--toast-info-bg))] text-[hsl(var(--toast-info-foreground))] border-[hsl(var(--toast-info-border))]",
          warning:
            "bg-[hsl(var(--toast-warning-bg))] text-[hsl(var(--toast-warning-foreground))] border-[hsl(var(--toast-warning-border))]",
          error:
            "bg-[hsl(var(--toast-error-bg))] text-[hsl(var(--toast-error-foreground))] border-[hsl(var(--toast-error-border))]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
